import type { MaterialOrderRequestColumn } from '../../types/column-types'

export const requestStatusColumn: MaterialOrderRequestColumn = {
    title: 'Статус',
    dataIndex: 'requestStatus',
    width: 70,
}
